module.exports = __webpack_public_path__ + "media/packs/site/assets/images/bnr_fr_first-1ae7226c71fa61d4777bf7cfbcf7f78e.png";